import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e6ff0ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-recommend-inner -is-form" }
const _hoisted_2 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_3 = { class: "p-recommend-form__list-2 js-entry-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__heading-1" }, "経験企業", -1))
const _hoisted_5 = { class: "p-recommend-form__group-1" }
const _hoisted_6 = { class: "p-recommend-form__error-wrap" }
const _hoisted_7 = { class: "p-recommend-form__group-1-field" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p class=\"p-recommend-form__text-1\" data-v-1e6ff0ce> 企業名 <span class=\"-is-required\" data-v-1e6ff0ce>必須</span><span class=\"resume-icon-wrapper --auto-right1\" data-v-1e6ff0ce><span class=\"text-label-highlight\" data-v-1e6ff0ce>履</span><span class=\"text-label-highlight\" data-v-1e6ff0ce>職</span></span></p>", 1)
const _hoisted_9 = { class: "p-recommend-form__group-1-field" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<p class=\"p-recommend-form__text-1\" data-v-1e6ff0ce> 勤務期間 <span class=\"-is-required\" data-v-1e6ff0ce>必須</span><span class=\"resume-icon-wrapper --auto-right1\" data-v-1e6ff0ce><span class=\"text-label-highlight\" data-v-1e6ff0ce>履</span><span class=\"text-label-highlight\" data-v-1e6ff0ce>職</span></span></p>", 1)
const _hoisted_11 = { class: "p-recommend-form__group-1-block-1" }
const _hoisted_12 = { class: "--wrap-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "--long" }, "〜", -1))
const _hoisted_14 = { class: "--wrap-1" }
const _hoisted_15 = { class: "p-recommend-form__group-1-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 部署名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_17 = { class: "p-recommend-form__group-1-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 職務内容 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_19 = { class: "p-recommend-form__group-1-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "雇用形態", -1))
const _hoisted_21 = { class: "p-recommend-form__group-1-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "役職", -1))
const _hoisted_23 = { class: "p-recommend-form__group-1-field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "年収", -1))
const _hoisted_25 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_27 = { class: "p-recommend-form__group-1-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "転職理由", -1))
const _hoisted_29 = { class: "p-recommend-form__group-1-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("企業の業種"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_31 = ["onClick", "value"]
const _hoisted_32 = { class: "p-recommend-form__group-1-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 事業内容 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_34 = { class: "p-recommend-form__group-1-field" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 資本金 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_36 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_38 = { class: "p-recommend-form__group-1-field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 従業員数 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_40 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人", -1))
const _hoisted_42 = { class: "p-recommend-form__group-1-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 上場・外資区分 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_44 = { class: "p-recommend-form__set-1" }
const _hoisted_45 = { class: "p-login-form__checkbox" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_47 = ["for"]
const _hoisted_48 = ["onClick", "disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "経験企業", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "を削除する", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "企業を追加する", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "p-recommend-form__send-field --2-buttons" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "前に戻る", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次へ進む", -1))
const _hoisted_59 = [
  _hoisted_58
]

import { BusinessCareerDetail, CareerResumeInfoDetail } from '@/types';
import { inject, ref, watch } from 'vue';
import YearMonthSelect from '../components/YearMonthSelect.vue';
import IndustryRadio from '@/components/IndustryRadio.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import { useFieldError, useFieldValue, useFormValues, ValidationResult } from 'vee-validate';
import InvalidMessage from '@/components/InvalidMessage.vue';

type Props = {
  activeTab: string;
  careerData?: CareerResumeInfoDetail;
  birthDateYear: number;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkExperienceForm',
  props: {
    activeTab: null,
    careerData: null,
    birthDateYear: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
  activeTab: string;
  careerData?: CareerResumeInfoDetail;
  birthDateYear: number;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
}

const MAX_BUSIESS_CAREER = 3;


const fieldIndices = ref<number[]>([]);

const minYearSelect = ref<number>(0);
const maxYearSelect = ref<number>(0);
const birthDateYValue = useFieldValue('birthDateY');
watch(birthDateYValue, (newVal: any) => {
  if (newVal) {
    minYearSelect.value = newVal + 13;
    maxYearSelect.value = newVal + 100;
  }
});
const getFieldError = (index: number) => {
  return useFieldError(`busicrDetails[${index}].indsctgId`);
};

const switchTabAndValidateFn = inject<(tabId: string) => void>('switchTabAndValidate');

const toEmpty = (v: any) => v ? v : '';
const values = useFormValues();
watch(() => props.careerData, (newVal?: CareerResumeInfoDetail) => {
  if (newVal) {
    setFormData(newVal);
  }
});

const businessCount = ref(0);
const businessDetails = ref<BusinessCareerDetail[]>([]);
const listBusiness = ref<{
  id: number,
  isActiveIndustryDialog: boolean;
  selectedInd: {
    indsctgId: number | null,
    indsctgText: string,
  }
}[]>([]);

function setFormData(formData: CareerResumeInfoDetail) {

  const business = [];
  if (formData.busicrDetails && formData.busicrDetails.length) {
    fieldIndices.value = Array.from({ length: formData.busicrDetails.length }, (_, i) => i);
    for (let i = 0; i < formData.busicrDetails.length; i++) {
        business.push(formData.busicrDetails[i]);
    }
  }


  const formObject = getFormDataFromBusiness(business);
  businessCount.value = business.length;
  businessDetails.value = [...business];
  if (business.length > 0) {
    business.forEach(b => {
      listBusiness.value.push({
        id: Math.random(),
        isActiveIndustryDialog: false,
        selectedInd: {
          indsctgId: toEmpty(b.indsctgId),
          indsctgText: '',
        },
      });
    });
  } else {
    // If no valid entries, keep at least one item
    listBusiness.value = [{
        id: Math.random(),
        isActiveIndustryDialog: false,
        selectedInd: {
          indsctgId: null,
          indsctgText: '',
        },
      }];
  }

  for (const key in formObject) {
    props.setFieldValue(key, formObject[key]);
  }
}
function getFormDataFromBusiness(business: BusinessCareerDetail[]) {
  const formObject: Record<string, any> = {};
  business.forEach((busi, i) => {

  let wkPeriodsYear = 0;
  let wkPeriodsMonth = 0;
  if(busi.wkPeriodsDate)
  {
    const [yearStr, monthStr] = busi.wkPeriodsDate.split('/');
    wkPeriodsYear = Number(yearStr);
    wkPeriodsMonth = Number(monthStr);
  }

  let wkPeriodeYear = 0;
  let wkPeriodeMonth = 0;
  if(busi.wkPeriodeDate)
  {
    const [yearStr, monthStr] = busi.wkPeriodeDate.split('/');
    wkPeriodeYear = Number(yearStr);
    wkPeriodeMonth = Number(monthStr);
  }


    formObject[`busicrDetails[${i}].busicrId`] = toEmpty(busi.busicrId)??0;
    formObject[`busicrDetails[${i}].compName`] = toEmpty(busi.compName);
    formObject[`busicrDetails[${i}].dept`] = toEmpty(busi.dept);
    formObject[`busicrDetails[${i}].indsctgId`] = toEmpty(busi.indsctgId);
    formObject[`busicrDetails[${i}].listedId`] = toEmpty(busi.listedId);
    formObject[`busicrDetails[${i}].frigncptlFlg`] = toEmpty(busi.frigncptlFlg);
    formObject[`busicrDetails[${i}].employeeNum`] = toEmpty(busi.employeeNum);
    formObject[`busicrDetails[${i}].capital`] = toEmpty(busi.capital);
    formObject[`busicrDetails[${i}].busiContents`] = toEmpty(busi.busiContents);
    formObject[`busicrDetails[${i}].annualIncm`] = toEmpty(busi.annualIncm);
    formObject[`busicrDetails[${i}].empTypeId`] = toEmpty(busi.empTypeId);
    formObject[`busicrDetails[${i}].post`] = toEmpty(busi.post);
    formObject[`busicrDetails[${i}].wkPeriodsDate`] = toEmpty(busi.wkPeriodsDate);
    formObject[`busicrDetails[${i}].wkPeriodsDateY`] = toEmpty(wkPeriodsYear);
    formObject[`busicrDetails[${i}].wkPeriodsDateM`] = toEmpty(wkPeriodsMonth);
    formObject[`busicrDetails[${i}].wkPeriodeDate`] = toEmpty(busi.wkPeriodeDate);
    formObject[`busicrDetails[${i}].wkPeriodeDateY`] = toEmpty(wkPeriodeYear);
    formObject[`busicrDetails[${i}].wkPeriodeDateM`] = toEmpty(wkPeriodeMonth);
    formObject[`busicrDetails[${i}].quitRsn`] = toEmpty(busi.quitRsn);
    formObject[`busicrDetails[${i}].wkContents`] = toEmpty(busi.wkContents);
    formObject[`busicrDetails[${i}].fromClassification`] = toEmpty(busi.fromClassification);
    formObject[`busicrDetails[${i}].toClassification`] = toEmpty(busi.toClassification);
  });

  return formObject;
}

const removeBusiness = async(idx:number) =>
{
  if (listBusiness.value.length > 1) {
    // Remove the item from listSchls
    // replace new values
    const len = listBusiness.value.length;
    for (let i = idx; i < len - 1; i++) {
      const bsDetail = values.value.busicrDetails[i + 1];

      listBusiness.value[i] = { ...listBusiness.value[i + 1], id: listBusiness.value[i].id };

      let wkPeriodsYear = 0;
      let wkPeriodsMonth = 0;
      if(bsDetail.wkPeriodsDate)
      {
        const [yearStr, monthStr] = bsDetail.wkPeriodsDate.split('/');
        wkPeriodsYear = Number(yearStr);
        wkPeriodsMonth = Number(monthStr);
      } else {
        wkPeriodsYear = bsDetail.wkPeriodsDateY;
        wkPeriodsMonth = bsDetail.wkPeriodsDateM;
      }
      let wkPeriodeYear = 0;
      let wkPeriodeMonth = 0;
      if(bsDetail.wkPeriodeDate)
      {
        const [yearStr, monthStr] = bsDetail.wkPeriodeDate.split('/');
        wkPeriodeYear = Number(yearStr);
        wkPeriodeMonth = Number(monthStr);
      } else {
        wkPeriodeYear = bsDetail.wkPeriodeDateY;
        wkPeriodeMonth = bsDetail.wkPeriodeDateM;
      }
      props.setFieldValue(`busicrDetails[${i}].busicrId`, toEmpty(bsDetail.busicrId));
      props.setFieldValue(`busicrDetails[${i}].compName`, toEmpty(bsDetail.compName));
      props.setFieldValue(`busicrDetails[${i}].dept`, toEmpty(bsDetail.dept));
      props.setFieldValue(`busicrDetails[${i}].indsctgId`, toEmpty(bsDetail.indsctgId));
      props.setFieldValue(`busicrDetails[${i}].listedId`, toEmpty(bsDetail.listedId));
      props.setFieldValue(`busicrDetails[${i}].frigncptlFlg`, toEmpty(bsDetail.frigncptlFlg));
      props.setFieldValue(`busicrDetails[${i}].employeeNum`, bsDetail.employeeNum);
      props.setFieldValue(`busicrDetails[${i}].capital`, bsDetail.capital);
      props.setFieldValue(`busicrDetails[${i}].busiContents`, toEmpty(bsDetail.busiContents));
      props.setFieldValue(`busicrDetails[${i}].annualIncm`, bsDetail.annualIncm);
      props.setFieldValue(`busicrDetails[${i}].empTypeId`, toEmpty(bsDetail.empTypeId));
      props.setFieldValue(`busicrDetails[${i}].post`, toEmpty(bsDetail.post));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodsDate`, toEmpty(bsDetail.wkPeriodsDate));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodsDateY`, toEmpty(wkPeriodsYear));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodsDateM`, toEmpty(wkPeriodsMonth));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodeDate`, toEmpty(bsDetail.wkPeriodeDate));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodeDateY`, toEmpty(wkPeriodeYear));
      props.setFieldValue(`busicrDetails[${i}].wkPeriodeDateM`, toEmpty(wkPeriodeMonth));
      props.setFieldValue(`busicrDetails[${i}].quitRsn`, toEmpty(bsDetail.quitRsn));
      props.setFieldValue(`busicrDetails[${i}].wkContents`, toEmpty(bsDetail.wkContents));
      props.setFieldValue(`busicrDetails[${i}].fromClassification`, toEmpty(bsDetail.fromClassification));
      props.setFieldValue(`busicrDetails[${i}].toClassification`, toEmpty(bsDetail.toClassification));
      await props.validateField(`busicrDetails[${i}].compName`);
      await props.validateField(`busicrDetails[${i}].fromClassification`);
      await props.validateField(`busicrDetails[${i}].toClassification`);
      await props.validateField(`busicrDetails[${i}].dept`);
      await props.validateField(`busicrDetails[${i}].wkContents`);
      await props.validateField(`busicrDetails[${i}].post`);
      await props.validateField(`busicrDetails[${i}].wkPeriodsDateY`);
      await props.validateField(`busicrDetails[${i}].wkPeriodsDateM`);
      await props.validateField(`busicrDetails[${i}].wkPeriodeDateY`);
      await props.validateField(`busicrDetails[${i}].wkPeriodeDateM`);
      await props.validateField(`busicrDetails[${i}].annualIncm`);
      await props.validateField(`busicrDetails[${i}].quitRsn`);
      await props.validateField(`busicrDetails[${i}].indsctgId`);
      await props.validateField(`busicrDetails[${i}].busiContents`);
      await props.validateField(`busicrDetails[${i}].capital`);
      await props.validateField(`busicrDetails[${i}].employeeNum`);
    }
    listBusiness.value.pop();
  }
};

async function setValueOfIndsctgId(industry:any)
{
  props.setFieldValue(industry.name, toEmpty(industry.indsctgId));
  await props.validateField(industry.name);
}

function addBusiness() {
  if (listBusiness.value.length >= MAX_BUSIESS_CAREER) return;
  listBusiness.value.push({
    id: Math.random(),
    isActiveIndustryDialog: false,
    selectedInd: {
      indsctgId: null,
      indsctgText: '',
    },
  });
  clearLastRecord(listBusiness.value.length - 1);
}

function clearLastRecord(index: number)
{
  props.setFieldValue(`busicrDetails[${index}].busicrId`, '');
  props.setFieldValue(`busicrDetails[${index}].compName`, '');
  props.setFieldValue(`busicrDetails[${index}].dept`, '');
  props.setFieldValue(`busicrDetails[${index}].indsctgId`, '');
  props.setFieldValue(`busicrDetails[${index}].listedId`, '');
  props.setFieldValue(`busicrDetails[${index}].frigncptlFlg`, '');
  props.setFieldValue(`busicrDetails[${index}].employeeNum`, '');
  props.setFieldValue(`busicrDetails[${index}].capital`, '');
  props.setFieldValue(`busicrDetails[${index}].busiContents`, '');
  props.setFieldValue(`busicrDetails[${index}].annualIncm`, '');
  props.setFieldValue(`busicrDetails[${index}].empTypeId`, '');
  props.setFieldValue(`busicrDetails[${index}].post`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodsDate`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodsDateY`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodsDateM`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodeDate`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodeDateY`, '');
  props.setFieldValue(`busicrDetails[${index}].wkPeriodeDateM`, '');
  props.setFieldValue(`busicrDetails[${index}].quitRsn`, '');
  props.setFieldValue(`busicrDetails[${index}].wkContents`, '');
  props.setFieldValue(`busicrDetails[${index}].fromClassification`, '');
  props.setFieldValue(`busicrDetails[${index}].toClassification`, '');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "workexperience",
    class: _normalizeClass(["tab-content", { 'show': __props.activeTab === 'workexperience' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listBusiness.value, (busi, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "js-entry-item js-tab-container",
              key: busi.id
            }, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].compName`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].wkPeriodsDateY`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].wkPeriodsDateM`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].fromClassification`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].wkPeriodeDateY`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].wkPeriodeDateM`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].toClassification`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].dept`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].wkContents`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].post`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].annualIncm`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].quitRsn`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].indsctgId`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].busiContents`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].capital`
                  }, null, 8, ["name"]),
                  _createVNode(InvalidMessage, {
                    name: `busicrDetails[${i}].employeeNum`
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(ValidatableField, {
                    name: `busicrDetails[${i}].busicrId`,
                    type: "hidden"
                  }, null, 8, ["name"]),
                  _createVNode(ValidatableField, {
                    class: "p-recommend-form__modal-input-2",
                    id: "form-experience-industry",
                    type: "text",
                    label: "企業名",
                    name: `busicrDetails[${i}].compName`,
                    placeholder: "入力してください",
                    rules: "required|max:50",
                    maxlength: "50"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(YearMonthSelect, {
                        "max-year": maxYearSelect.value,
                        "min-year": minYearSelect.value,
                        label: "勤務期間（開始）",
                        "sub-label": "に",
                        name: { year: `busicrDetails[${i}].wkPeriodsDateY`, month: `busicrDetails[${i}].wkPeriodsDateM` },
                        isRequired: true
                      }, null, 8, ["max-year", "min-year", "name"])
                    ]),
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__input-1 --long",
                      id: "form-experience-start-reason",
                      placeholder: "入社、出向、帰任、転職 など",
                      name: `busicrDetails[${i}].fromClassification`,
                      label: "内容（開始）",
                      rules: "required|max:15",
                      maxlength: "15"
                    }, null, 8, ["name"]),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(YearMonthSelect, {
                        "max-year": maxYearSelect.value,
                        "min-year": minYearSelect.value,
                        label: "勤務期間（終了）",
                        "sub-label": "に",
                        rules: {
                        year: [
                          `lteYearMonth:busicrDetails[${i}].wkPeriodsDateY,busicrDetails[${i}].wkPeriodsDateM,busicrDetails[${i}].wkPeriodeDateY,busicrDetails[${i}].wkPeriodeDateM`,
                        ].join('|')
                      },
                        name: { year: `busicrDetails[${i}].wkPeriodeDateY`, month: `busicrDetails[${i}].wkPeriodeDateM` }
                      }, null, 8, ["max-year", "min-year", "rules", "name"])
                    ]),
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__input-1 --long",
                      id: "form-experience-end-reason",
                      placeholder: "一身上の都合により退職 など",
                      name: `busicrDetails[${i}].toClassification`,
                      rules: "max:15",
                      maxlength: "15",
                      label: "内容（終了）"
                    }, null, 8, ["name"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(ValidatableField, {
                    class: "p-recommend-form__modal-input-2",
                    id: "form-experience-department-1",
                    type: "text",
                    name: `busicrDetails[${i}].dept`,
                    placeholder: "入力してください",
                    label: "部署名",
                    rules: "max:1000",
                    maxlength: "1000"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(ValidatableField, {
                    as: "textarea",
                    class: "p-recommend-form__textarea --extra-height-1",
                    id: "form-experience-description",
                    type: "textarea",
                    name: `busicrDetails[${i}].wkContents`,
                    placeholder: "例）【担当業務】\n・企画営業（既存顧客 100％）\n……担当店舗の巡回・自社玩具の販売動向の報告・成功事例の抽出\n・販売促進\n……販促物の作成、売場レイアウト作成、店頭での販売応援・キャンペーン実施\n・新人育成指導\n\n【取扱商品】\n玩具全般\n\n【担当顧客】\n百貨店15店舗・専門店等 約100店舗（内巡回店舗15店舗）\n\n【工夫した点】\n売場責任者との密なコミュニケーションによる店頭での課題抽出と迅速な解決\n\n【実績】\n20xx年度 目標xx億円 /実績xx億円 /達成率 102％\n20xx年度 目標xx億円 /実績xx億円 /達成率 120％\n※xx月の月間営業賞受賞（販促プランの功績による受賞）",
                    label: "職務内容",
                    rules: "max:30000",
                    maxlength: "30000"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(ResumeSelect, {
                    name: `busicrDetails[${i}].empTypeId`,
                    label: "雇用形態",
                    id: "emptype",
                    className: "p-recommend-form__select"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(ValidatableField, {
                    class: "p-recommend-form__modal-input-2",
                    id: "form-experience-post",
                    type: "text",
                    name: `busicrDetails[${i}].post`,
                    placeholder: "入力してください",
                    label: "役職",
                    rules: "max:50",
                    maxlength: "50"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__modal-input-2",
                      id: "form-experience-salary",
                      type: "text",
                      name: `busicrDetails[${i}].annualIncm`,
                      placeholder: "0",
                      label: "年収",
                      rules: "numeric|max:4",
                      maxlength: "4"
                    }, null, 8, ["name"]),
                    _hoisted_26
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(ValidatableField, {
                    as: "textarea",
                    class: "p-recommend-form__textarea --extra-height-1",
                    id: "form-experience-message-1",
                    type: "textarea",
                    name: `busicrDetails[${i}].quitRsn`,
                    placeholder: "例）より良い人間関係を築きたい／残業を減らしワークライフバランスを重視したい／結婚を機に生活スタイルが変わったため ※転職理由は履歴書・職務経歴書には反映されません。",
                    label: "転職理由",
                    rules: "max:2000",
                    maxlength: "2000"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("input", {
                    class: _normalizeClass(["p-recommend-form__modal-input-1", {'--is-error': !!getFieldError(i).value}]),
                    id: "form-experience-industry-type",
                    type: "text",
                    name: "form-experience-industry-type",
                    onClick: ($event: any) => (listBusiness.value[i].isActiveIndustryDialog = true),
                    readonly: "",
                    value: listBusiness.value[i].selectedInd.indsctgText,
                    placeholder: "業種を選択"
                  }, null, 10, _hoisted_31),
                  _createVNode(ValidatableField, {
                    type: "hidden",
                    value: listBusiness.value[i].selectedInd.indsctgId,
                    name: `busicrDetails[${i}].indsctgId`,
                    label: "企業の業種",
                    rules: "required"
                  }, null, 8, ["value", "name"]),
                  _createVNode(IndustryRadio, {
                    "is-active": listBusiness.value[i].isActiveIndustryDialog,
                    "onUpdate:is-active": ($event: any) => ((listBusiness.value[i].isActiveIndustryDialog) = $event),
                    "selected-industry": listBusiness.value[i].selectedInd,
                    "onUpdate:selected-industry": ($event: any) => ((listBusiness.value[i].selectedInd) = $event),
                    nameElement: `busicrDetails[${i}].indsctgId`,
                    "onUpdate:setValue": setValueOfIndsctgId,
                    name: `industry-${i}-wrkexp`
                  }, null, 8, ["is-active", "onUpdate:is-active", "selected-industry", "onUpdate:selected-industry", "nameElement", "name"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(ValidatableField, {
                    as: "textarea",
                    class: "p-recommend-form__textarea --extra-height-1",
                    id: "form-experience-message-2",
                    type: "textarea",
                    name: `busicrDetails[${i}].busiContents`,
                    placeholder: "例）玩具・雑貨の企画・製造及び販売／アプリケーション・ソフトウェアシステム開発／自動車部品製造業",
                    label: "事業内容",
                    rules: "max:500",
                    maxlength: "500"
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__modal-input-2",
                      id: "form-experience-capital",
                      type: "text",
                      name: `busicrDetails[${i}].capital`,
                      placeholder: "0",
                      label: "資本金",
                      rules: "numeric|max:13",
                      maxlength: "13"
                    }, null, 8, ["name"]),
                    _hoisted_37
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__modal-input-2",
                      id: "form-experience-employees",
                      type: "text",
                      name: `busicrDetails[${i}].employeeNum`,
                      placeholder: "0",
                      label: "従業員数",
                      rules: "numeric|max:6",
                      maxlength: "6"
                    }, null, 8, ["name"]),
                    _hoisted_41
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(ResumeSelect, {
                    name: `busicrDetails[${i}].listedId`,
                    label: "上場・外資区分",
                    id: "listed",
                    className: "p-recommend-form__select",
                    "is-filter": true
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, [
                      _createVNode(ValidatableField, {
                        id: `form-experience-foreign-investment-${i}`,
                        type: "checkbox",
                        value: 2,
                        name: `busicrDetails[${i}].frigncptlFlg`,
                        label: "外資"
                      }, null, 8, ["id", "name"]),
                      _hoisted_46
                    ]),
                    _createElementVNode("label", {
                      class: "p-recommend-form__label",
                      for: `form-experience-foreign-investment-${i}`
                    }, "外資", 8, _hoisted_47)
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "p-recommend-form__delete-2",
                type: "button",
                onClick: ($event: any) => (removeBusiness(i)),
                disabled: listBusiness.value.length <= 1
              }, _hoisted_51, 8, _hoisted_48)
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "p-recommend-form__add --mt-2",
          type: "button",
          onClick: addBusiness,
          disabled: listBusiness.value.length >= MAX_BUSIESS_CAREER
        }, _hoisted_54, 8, _hoisted_52)
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-prev", { 'active': __props.activeTab === 'worksummary' }]),
          href: "#worksummary",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#worksummary')), ["prevent"]))
        }, _hoisted_57, 2),
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-next", { 'active': __props.activeTab === 'education' }]),
          href: "#education",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#education')), ["prevent"]))
        }, _hoisted_59, 2)
      ])
    ])
  ], 2))
}
}

})